import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
function normalizar(caminho) {
    if (caminho === '/ingestao' || caminho === '/viewer') {
        return caminho;
    }
    return '/';
}
/** Caminho atual do browser, sincronizado com a History API (back/forward incluídos). */
export function useRota() {
    const [rota, setRota] = useState(() => normalizar(window.location.pathname));
    useEffect(() => {
        const aoNavegar = () => setRota(normalizar(window.location.pathname));
        window.addEventListener('popstate', aoNavegar);
        return () => window.removeEventListener('popstate', aoNavegar);
    }, []);
    const navegarPara = useCallback((destino) => {
        if (destino !== window.location.pathname) {
            window.history.pushState(null, '', destino);
        }
        setRota(destino);
    }, []);
    return [rota, navegarPara];
}
/** Link interno que navega via History API em vez de recarregar o documento. */
export function LinkDeRota({ para, navegarPara, className, children }) {
    return (_jsx("a", { href: para, className: className, onClick: (evento) => {
            evento.preventDefault();
            navegarPara(para);
        }, children: children }));
}
